import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Cierre from "pages/Cierre";
import Carga from "pages/Carga";
import Reporte from "pages/Reporte";
import AlertDb from "components/AlertDb";
const App = () => {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/cierre" component={Cierre} />
          <Route path="/reporte" component={Reporte} />
          <Route path="/" component={Carga} />
        </Switch>
      </Router>
      <AlertDb />
    </>
  );
};

export default App;
